export class EventInfo {
  company: string;
  userId: string;
  sessionId: string;
  boardId: string;

  constructor(public topic: string) {
    const [_app, _module, _version, company, userId, sessionId, boardId] = topic.split(".");
    this.company = company;
    this.userId = userId;
    this.sessionId = sessionId;
    this.boardId = boardId;
  }
}
